import React from 'react';
import PropTypes from 'prop-types';

const UserProfileEmail = ({ profile }) => (
  <li className="user-profile-email">
    <i className="far fa-envelope" />
    <a href={`mailto:${profile.email}`}>
      {profile.email}
    </a>
  </li>
);

UserProfileEmail.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default UserProfileEmail;
